import { AlertCategory, AlertSeverity } from '@app/client/settings/user/modules/alert-settings/alert-settings.model';
import { AdPlatform } from '@app/core/models/common.models';
import { StateToken } from '@ngxs/store';

export interface AlertsStateModel {
  alerts: Partial<Record<AlertSource, Alert[]>>;
  unreadCount?: number;
  categories?: AlertCategory[];
}

export type AlertSource = 'drawer' | 'page';

export enum AlertCategoryId {
  BudgetSuggestions = 'budget-suggestions',
  Campaigns = 'campaigns',
  Conversions = 'conversions',
  Criterion = 'criterion',
  Goals = 'goals',
  KeywordSuggestions = 'keyword-suggestions',
  Optimization = 'optimization',
  Products = 'products',
  Promotion = 'promotions',
}

export interface AlertListItem {
  text: string;
  link: string | null;
}

export interface Alert {
  adspertAccountId: number;
  // @searchable
  accountId: string;
  // @searchable
  accountName: string;
  accountPlatform: AdPlatform;
  // @searchable
  accountTagsUser: string[];
  categoryId: AlertCategoryId;
  // @searchable
  categoryName: string;
  customerId: number;
  instanceId: number;
  definitionId: string;
  // @searchable
  title: string;
  // @searchable
  message: string;
  listItems: AlertListItem[];
  severity: AlertSeverity;
  actionPrimaryText: string;
  actionPrimaryLink: string;
  actionSecondaryText: string;
  actionSecondaryLink: string;
  createdAt: string;
  read: boolean;
  cleared: boolean;
  clearedAt?: string;
  clearedByEmail?: string;
  clearedByName?: string;
  muted: boolean;
  mutedUntil: string | null;
}

export const ALERT_STATE = new StateToken<AlertsStateModel>('alerts');
